import { Divider, Box } from '@mui/material';
import type { RestoreJob } from '@repo/api-gw-sdk';

import { PanelWrapper } from '@/components/panels/panelWrapper';
import { useWorkspace } from '@/contexts/useWorkspace';

import { JobItemFields } from './jobItemFields';
import { JobStatusCard } from './jobStatusCard';
import { OperationSummary } from './operationSummary';
import {
  restoreJobItemFields,
  restoreJobSummaryFromFields,
  restoreJobSummaryToFields,
} from './restoreJobItemFields';

interface RestoreJobsCardProps {
  job: RestoreJob;
  unselectJob?: () => void;
}

export const RestoreJobsCard = ({ job, unselectJob }: RestoreJobsCardProps) => {
  const { rightPanel } = useWorkspace();

  return (
    <PanelWrapper
      header={{
        title: 'Job details',
        onClose: () => {
          rightPanel.setIsOpen(false);
          unselectJob?.();
        },
        hideBorder: true,
      }}
      testIdPrefix='restore-jobs-card'
    >
      <RestoreJobsCardContent job={job} />
    </PanelWrapper>
  );
};

const RestoreJobsCardContent = ({ job }: { job: RestoreJob }) => {
  const fromCloudProvider = job.vault?.cloudProvider;
  const toCloudProvider = job.destinationDetails.cloudProvider;

  return (
    <Box className='pb-[40px]' overflow='auto'>
      <JobItemFields job={job} fields={restoreJobItemFields} />
      <Divider />
      <JobStatusCard job={job} />
      <OperationSummary
        job={job}
        fromTitle='Restore from'
        fromFields={restoreJobSummaryFromFields}
        fromCloudProvider={fromCloudProvider!} // todo: remove this after making vault required.
        toTitle='Restore to'
        toFields={restoreJobSummaryToFields}
        toCloudProvider={toCloudProvider}
      />
    </Box>
  );
};
